/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MemberShareResponseDto { 
    totaAmountofShare?: number;
    blockedAmount?: number;
    shareName?: string | null;
    totalShares?: number;
    shareId?: number;
    accountId?: number;
    accountNumber?: string | null;
    allowedAsGuarantor?: boolean;
    allowedAsCollateral?: boolean;
    balance?: number;
    openingBalance?: number | null;
    accountStatus?: string | null;
    memberName?: string | null;
}

